export type CachePolicy = "cache-first" | "network-only";
export type InstallMode = "ios-manual" | "native-prompt" | "none";
export const INSTALL_PROMPT_DECISION_KEY = "horosho.install.prompt.decided.v2";

type InstallPromptStorage = Pick<Storage, "getItem" | "setItem">;

export type InstallEnvironment = {
  userAgent: string;
  maxTouchPoints?: number;
  standalone: boolean;
  promptAvailable: boolean;
};

export function cachePolicyFor(
  url: URL,
  appOrigin = "https://horosho.capital"
): CachePolicy {
  if (url.origin !== appOrigin || url.pathname.startsWith("/api/")) {
    return "network-only";
  }
  return url.pathname === "/offline.css" ||
    url.pathname === "/offline.js" ||
    url.pathname.startsWith("/icons/") ||
    url.pathname.startsWith("/assets/")
    ? "cache-first"
    : "network-only";
}

export function installMode(environment: InstallEnvironment): InstallMode {
  if (environment.standalone) return "none";
  if (environment.promptAvailable) return "native-prompt";
  const userAgent = environment.userAgent;
  const mobileIos = /iPad|iPhone|iPod/i.test(userAgent);
  const desktopClassIpad = /Macintosh|Mac OS X/i.test(userAgent) && (environment.maxTouchPoints ?? 0) > 1;
  return mobileIos || desktopClassIpad ? "ios-manual" : "none";
}

export function hasInstallPromptDecision(storage: InstallPromptStorage): boolean {
  try {
    return storage.getItem(INSTALL_PROMPT_DECISION_KEY) === "1";
  } catch {
    return false;
  }
}

export function rememberInstallPromptDecision(storage: InstallPromptStorage): void {
  try {
    storage.setItem(INSTALL_PROMPT_DECISION_KEY, "1");
  } catch {
    // The in-memory UI state still suppresses the prompt for this page session.
  }
}

export function shouldReloadForControllerChange(updateRequested: boolean): boolean {
  return updateRequested;
}
